import client from 'core/axios';
import handleError from 'core/axios/handleError';
import {
  handleJSONResponse,
  handleFileDownloadResponse,
} from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getStudentDetails = ({
  studentId,
  params = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/casefile/student/${studentId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const downloadStudentListCSV = ({
  params = {},
  payload = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/student-list-csv/`,
      method: RequestMethod.POST,
      params,
      data: payload,
    })
    .then(handleFileDownloadResponse)
    .catch(handleError);

/**
 * Used to create student note
 * @param studentId
 * @param payload.description
 * @param payload.duration
 * @param payload.hasFollowUp
 * @param payload.isVisibilityRestricted
 * @param payload.meetingDate
 * @param payload.noteTags
 * @param payload.recordType
 * @param payload.reminderDate
 * @param payload.tags
 * @param payload.title
 */
export const saveStudentNote = ({ studentId, version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/notes/${studentId}/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to update student note
 * @param noteId
 * @param payload.description
 * @param payload.duration
 * @param payload.hasFollowUp
 * @param payload.isVisibilityRestricted
 * @param payload.meetingDate
 * @param payload.noteTags
 * @param payload.recordType
 * @param payload.reminderDate
 * @param payload.tags
 * @param payload.title
 */
export const updateStudentNote = ({ noteId, version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/notes-list/${noteId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to update student note
 * @param noteId
 */
export const deleteStudentNote = ({ noteId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/notes-list/${noteId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getNotes = ({ studentId, params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/notes/${studentId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getNotesForStudent = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/notes/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getNoteTags = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/note-tags/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to create a note tag
 *
 * @param payload.name
 */
export const createNoteTag = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/note-tags/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to update a note tag
 *
 * @param tagId
 * @param payload.name
 */
export const updateNoteTag = ({ tagId, version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/note-tags/${tagId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Used to delete a note tag
 *
 * @param tagId
 */
export const deleteNoteTag = ({ tagId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/counselor_dashboard/note-tags/${tagId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);
